import { render, staticRenderFns } from "./fleet.cattle.io.bundle.vue?vue&type=template&id=478ddae3&"
import script from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js&"
export * from "./fleet.cattle.io.bundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports